let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4d6AY")).then(() => parcelRequire('3aXuO'));